import { RiGhost2Fill } from 'react-icons/ri'

import './empty.css'

const Empty = ({title}) => {

      return (
            <div className="empty_content">
                  <div className="empty_icon">
                        <RiGhost2Fill />
                  </div>
                  <h3>{title}</h3>
            </div>
      )
}

export default Empty
